import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ConfirmDialog.css';

function ConfirmDialog({ show, onHide, onConfirm, title, message, confirmText = 'Confirm', cancelText = 'Cancel', variant = 'danger' }) {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="confirm-dialog">
      <Modal.Body className="text-center p-4">
        <div className={`confirm-icon confirm-icon-${variant}`}>
          {variant === 'danger' && <i className="bi bi-exclamation-triangle"></i>}
          {variant === 'warning' && <i className="bi bi-exclamation-circle"></i>}
          {variant === 'info' && <i className="bi bi-info-circle"></i>}
          {variant === 'success' && <i className="bi bi-check-circle"></i>}
        </div>
        <h5 className="confirm-title">{title}</h5>
        <p className="confirm-message">{message}</p>
        <div className="confirm-buttons">
          <Button variant="outline-secondary" onClick={onHide} className="confirm-btn-cancel">
            {cancelText}
          </Button>
          <Button variant={variant} onClick={handleConfirm} className="confirm-btn-action">
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmDialog;
